import React from 'react';

const NotAuthorize = () => {
    return (<div>Not Authorize</div>);
}

export default NotAuthorize;